export default __webpack_public_path__ + "static/Bm_EFTB_iMedical_Declaration-c8de0faa851c1f2ea54be59eee534203.pdf";